import React, { MouseEvent, ReactNode } from 'react'
import { CalcType } from '../model/enums'

interface ITabLinksProps {
  children: ReactNode
}

const TabLinks = ({ children }: ITabLinksProps) => {
  return (
    <div className='csas-calc-row'>
      <div className='csas-tabs'>{children}</div>
    </div>
  )
}

interface ITabLinkProps {
  label: string
  isActive: boolean
  value: CalcType
  rf: string
  onClick: (type: CalcType) => void
}

const TAB_LINK_CLASS = 'csas-tablinks'
const TAB_LINK_ACTIVE_CLASS = TAB_LINK_CLASS + ' active'

const TabLink = ({ label, isActive, value, rf, onClick }: ITabLinkProps) => {
  const handleClick = () => onClick(value)
  return (
    <button
      data-rf={rf}
      value={value}
      onClick={handleClick}
      className={isActive ? TAB_LINK_ACTIVE_CLASS : TAB_LINK_CLASS}
    >
      {label}
    </button>
  )
}

export { TabLink, TabLinks }
